import ReviewActions from '@components/Reviews/Review/ReviewActions';
import StarBarAndRating from '@components/Reviews/DefaultRenderedComponents/StarsRatingBar';
import { ReviewsTextKeys } from '@components/Reviews/types';
import ReviewSubjectLink from '@components/Reviews/Review/ReviewSubjectLink';
import VerticalDivider from '@components/VerticalDivider';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import _ from 'lodash';
import { FC } from 'react';
import { IHandleBIGenericClick, ReviewData } from '@common/types';
import s from './SingleReviewHeader.module.scss';

type SingleReviewHeaderProps = {
  review: ReviewData;
  showActionButtons?: boolean;
  onEdit?: () => void;
  isMobileView?: boolean;
  handleBiGenericClick?: IHandleBIGenericClick;
  i18nKeys: Partial<ReviewsTextKeys>;
};

const SingleReviewHeader: FC<SingleReviewHeaderProps> = ({
  review,
  showActionButtons,
  onEdit,
  isMobileView,
  handleBiGenericClick,
  i18nKeys: { viewReviewSubjectCTA },
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <Box dataHook="review-header" display="block">
      <Box align="space-between" width="100%">
        {!_.isNil(review?.overallScore) && (
          <StarBarAndRating
            overallScore={review.overallScore}
            numericalRatings={{
              className: s.numericalRating,
            }}
          />
        )}
        {showActionButtons && (
          <ReviewActions
            review={review}
            onEdit={onEdit}
            isMobileView={isMobileView}
          />
        )}
      </Box>
      <Box paddingBottom="SP2" width="100%" verticalAlign="middle">
        {review.clientName && (
          <>
            <Text
              size="tiny"
              weight="thin"
              secondary
              dataHook="review-client-name"
            >{`${review.clientName}`}</Text>
            <VerticalDivider />
          </>
        )}
        {review.date && (
          <>
            <Text size="tiny" weight="thin" secondary dataHook="review-date">
              {review.date &&
                Intl.DateTimeFormat(language, {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                }).format(new Date(review.date))}
            </Text>
          </>
        )}
        {review.url && (
          <ReviewSubjectLink
            id={review.id}
            url={review.url}
            handleBiGenericClick={handleBiGenericClick}
            urlCtaKey={viewReviewSubjectCTA || ''}
          />
        )}
      </Box>
    </Box>
  );
};

export default SingleReviewHeader;
